// import React, { useEffect, useMemo, useState } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import bannerone from "../../Assets/Banner/Wooden Craft.png";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import { useCart } from "../../utils/CartContext";
// import { Star, Loader2, Heart } from "lucide-react";
// import { useCurrency } from "../../context/CurrencyContext";
// import { formatingPrice } from "../../utils/formatingPrice";
// import { useTranslation } from "react-i18next";

// const ProductFilterSection = ({ products = [], loading, searchQuery }) => {
//   const navigate = useNavigate();
//   const { fetchCartCount } = useCart();
//   const { currency, convertPrice } = useCurrency();
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language || "en";

//   // FILTER STATES
//   const [openFilter, setOpenFilter] = useState(null);
//   const [priceSort, setPriceSort] = useState(null);
//   const [ratingMin, setRatingMin] = useState(0);
//   const [selectedBrands, setSelectedBrands] = useState(new Set());
//   const [selectedMaterials, setSelectedMaterials] = useState(new Set());
//   const [selectedHeights, setSelectedHeights] = useState(new Set());
//   const [selectedWeights, setSelectedWeights] = useState(new Set());
//   const [selectedMeasurements, setSelectedMeasurements] = useState(new Set());
//   const ratingOptions = [5, 4, 3, 2, 1];

//   // WISHLIST + CART
//   const [wishlist, setWishlist] = useState([]);
//   const [loadingHearts, setLoadingHearts] = useState(new Set());
//   const [loadingCart, setLoadingCart] = useState(new Set());

//   const storedUser = localStorage.getItem("pm-user-data");
//   const user = storedUser ? JSON.parse(storedUser) : null;
//   const userId = user?._id;

//   // Helper function to get localized text
//   const getLocalizedText = (item, field) => {
//     if (!item || !item[field]) return "";
    
//     // If value is a string (backward compatibility)
//     if (typeof item[field] === 'string') {
//       return item[field];
//     }
    
//     // If value is an object with language keys
//     if (typeof item[field] === 'object') {
//       return item[field][currentLanguage] || 
//              item[field].en || 
//              item[field].hi || 
//              item[field].es || 
//              item[field].zh || 
//              "";
//     }
    
//     return "";
//   };

//   // INIT AOS + FETCH WISHLIST
//   useEffect(() => {
//     AOS.init({ duration: 800, once: true });

//     if (userId) fetchWishlist();
//   }, [userId]);

//   // Fetch wishlist
//   const fetchWishlist = async () => {
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/wishlist/wishlist-by-user/${userId}`
//       );
//       const ids = res?.data?.products?.map((p) => p._id?.toString()) || [];
//       setWishlist(ids);
//     } catch {}
//   };

//   // Toggle wishlist
//   const toggleWishlist = async (productId) => {
//     if (!userId) {
//       toast.error(t("product_filter.please_login") || "Please login ❤️");
//       return;
//     }

//     const liked = wishlist.includes(productId);
//     setLoadingHearts((prev) => new Set(prev).add(productId));

//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}/wishlist/${
//           liked ? "remove-from-wishlist" : "add-to-wishlist"
//         }`,
//         { userId, productId }
//       );

//       fetchWishlist();
//       toast.success(
//         liked 
//           ? t("product_filter.removed_wishlist") || "Removed from wishlist"
//           : t("product_filter.added_wishlist") || "Added to wishlist"
//       );
//     } catch (error) {
//       toast.error(t("product_filter.wishlist_error") || "Failed to update wishlist");
//     } finally {
//       setLoadingHearts((prev) => {
//         const n = new Set(prev);
//         n.delete(productId);
//         return n;
//       });
//     }
//   };

//   // Add to cart
//   const handleAddToCart = async (productId) => {
//     if (!userId) {
//       toast.error(t("product_filter.please_login_cart") || "Please login 🛒");
//       return;
//     }

//     setLoadingCart((prev) => new Set(prev).add(productId));

//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}/cart/add-product-to-cart`,
//         { userId, productId, quantity: 1 }
//       );
//       toast.success(t("product_filter.added_cart") || "Added to cart!");
//       fetchCartCount();
//     } catch (error) {
//       toast.error(t("product_filter.cart_error") || "Failed to add to cart");
//     } finally {
//       setLoadingCart((prev) => {
//         const n = new Set(prev);
//         n.delete(productId);
//         return n;
//       });
//     }
//   };

//   // Filter options - use localized text for display
//   const heightOptions = useMemo(() => {
//     const s = new Set();
//     products?.forEach((p) => {
//       const height = p.height;
//       if (height) s.add(height);
//     });
//     return [...s];
//   }, [products]);

//   const weightOptions = useMemo(() => {
//     const s = new Set();
//     products?.forEach((p) => {
//       const weight = p.weight;
//       if (weight) s.add(weight);
//     });
//     return [...s];
//   }, [products]);

//   const measurementOptions = useMemo(() => {
//     const s = new Set();
//     products?.forEach((p) => {
//       const measurement = getLocalizedText(p, "measurement");
//       if (measurement) s.add(measurement);
//     });
//     return [...s];
//   }, [products, getLocalizedText]);

//   const brandOptions = useMemo(() => {
//     const s = new Set();
//     products?.forEach((p) => {
//       const brand = p.brand;
//       if (brand) s.add(brand);
//     });
//     return [...s];
//   }, [products]);

//   const materialOptions = useMemo(() => {
//     const s = new Set();
//     products?.forEach((p) => {
//       const material = getLocalizedText(p, "material");
//       if (material) s.add(material);
//     });
//     return [...s];
//   }, [products, getLocalizedText]);

//   // Apply filters
//   const filteredProducts = useMemo(() => {
//     let list = [...products];

//     // Rating filter
//     if (ratingMin > 0) {
//       list = list.filter((p) => {
//         const r = typeof p.ratings === "number" ? p.ratings : 0;
//         return r >= ratingMin;
//       });
//     }

//     // Brand filter - exact match since brand is usually a string
//     if (selectedBrands.size > 0) {
//       list = list.filter((p) => selectedBrands.has(p.brand));
//     }

//     // Material filter - use localized text for comparison
//     if (selectedMaterials.size > 0) {
//       list = list.filter((p) => {
//         const materialText = getLocalizedText(p, "material");
//         return selectedMaterials.has(materialText);
//       });
//     }

//     // Height filter
//     if (selectedHeights.size > 0) {
//       list = list.filter((p) => selectedHeights.has(p.height));
//     }

//     // Weight filter
//     if (selectedWeights.size > 0) {
//       list = list.filter((p) => selectedWeights.has(p.weight));
//     }

//     // Measurement filter - use localized text for comparison
//     if (selectedMeasurements.size > 0) {
//       list = list.filter((p) => {
//         const measurementText = getLocalizedText(p, "measurement");
//         return selectedMeasurements.has(measurementText);
//       });
//     }

//     // Price sort
//     if (priceSort === "asc") list.sort((a, b) => a.price - b.price);
//     if (priceSort === "desc") list.sort((a, b) => b.price - a.price);

//     return list;
//   }, [
//     products,
//     priceSort,
//     ratingMin,
//     selectedBrands,
//     selectedMaterials,
//     selectedHeights,
//     selectedWeights,
//     selectedMeasurements,
//     getLocalizedText,
//   ]);

//   // toggle set
//   const toggleSet = (setter, refSet, value) => {
//     const s = new Set(refSet);
//     s.has(value) ? s.delete(value) : s.add(value);
//     setter(s);
//   };

//   // Reset filters
//   const resetFilters = () => {
//     setPriceSort(null);
//     setRatingMin(0);
//     setSelectedBrands(new Set());
//     setSelectedMaterials(new Set());
//     setSelectedHeights(new Set());
//     setSelectedWeights(new Set());
//     setSelectedMeasurements(new Set());
//     setOpenFilter(null);
//   };

//   // Star Renderer
//   const renderStars = (rating) => (
//     <div className="flex justify-center gap-1 mb-2">
//       {[...Array(5)].map((_, index) => (
//         <Star
//           key={index}
//           className={`w-4 h-4 ${
//             index < Math.round(rating)
//               ? "text-yellow-400 fill-yellow-400"
//               : "text-gray-300"
//           }`}
//         />
//       ))}
//       {rating && (
//         <span className="text-xs text-gray-500 ml-1">{rating.toFixed(1)}</span>
//       )}
//     </div>
//   );

//   // SHOW LOADER
//   if (loading)
//     return (
//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 px-4 md:px-10 py-10">
//         {[...Array(10)].map((_, i) => (
//           <div
//             key={i}
//             className="bg-[#f7f3f3] rounded-lg overflow-hidden shadow-sm animate-pulse"
//           >
//             {/* Image Skeleton */}
//             <div className="w-full aspect-square bg-gray-300"></div>

//             {/* Content */}
//             <div className="p-3 space-y-3">
//               {/* Rating */}
//               <div className="flex justify-center gap-2">
//                 <div className="w-4 h-4 bg-gray-300 rounded"></div>
//                 <div className="w-4 h-4 bg-gray-300 rounded"></div>
//                 <div className="w-4 h-4 bg-gray-300 rounded"></div>
//                 <div className="w-4 h-4 bg-gray-300 rounded"></div>
//                 <div className="w-4 h-4 bg-gray-300 rounded"></div>
//               </div>

//               {/* Product name */}
//               <div className="h-3 bg-gray-300 rounded w-3/4 mx-auto"></div>
//               <div className="h-3 bg-gray-300 rounded w-1/2 mx-auto"></div>

//               {/* Price */}
//               <div className="flex justify-center gap-3">
//                 <div className="h-4 bg-gray-300 rounded w-12"></div>
//                 <div className="h-4 bg-gray-300 rounded w-16"></div>
//               </div>

//               {/* Button */}
//               <div className="h-8 bg-gray-300 rounded w-full mt-4"></div>
//             </div>
//           </div>
//         ))}
//       </div>
//     );

//   // Show no results message for search
//   if (searchQuery && filteredProducts.length === 0) {
//     return (
//       <div className="text-center py-16">
//         <div className="max-w-md mx-auto">
//           <h3 className="text-xl font-semibold text-gray-800 mb-2">
//             {t("product_filter.no_search_results") || "No products found"}
//           </h3>
//           <p className="text-gray-600 mb-6">
//             {t("product_filter.try_different_search") || "Try a different search term"}
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="bg-white py-10 px-4 md:px-10">
//       {/* Results count */}
//       {searchQuery && (
//         <div className="mb-6">
//           <p className="text-gray-600">
//             {t("product_filter.results_found", { count: filteredProducts.length }) || 
//               `${filteredProducts.length} results found`}
//           </p>
//         </div>
//       )}

//       {/* FILTER BUTTONS */}
//       <div className="flex flex-wrap gap-2 mb-6">
//         <button
//           onClick={() => setOpenFilter(openFilter === "all" ? null : "all")}
//           className={`px-4 py-2 border rounded-full ${
//             openFilter === "all" ? "bg-black text-white" : "bg-white text-black"
//           }`}
//         >
//           {t("product_filter.all_filters") || "All Filters"}
//         </button>

//         <button
//           onClick={() =>
//             setOpenFilter(openFilter === "height" ? null : "height")
//           }
//           className={`px-4 py-2 border rounded-full ${
//             openFilter === "height" ? "bg-gray-900 text-white" : "bg-white text-black"
//           }`}
//         >
//           {t("product_filter.height") || "Height"}
//         </button>

//         <button
//           onClick={() =>
//             setOpenFilter(openFilter === "weight" ? null : "weight")
//           }
//           className={`px-4 py-2 border rounded-full ${
//             openFilter === "weight" ? "bg-gray-900 text-white" : "bg-white text-black"
//           }`}
//         >
//           {t("product_filter.weight") || "Weight"}
//         </button>

//         <button
//           onClick={() =>
//             setOpenFilter(openFilter === "measurement" ? null : "measurement")
//           }
//           className={`px-4 py-2 border rounded-full ${
//             openFilter === "measurement" ? "bg-gray-900 text-white" : "bg-white text-black"
//           }`}
//         >
//           {t("product_filter.measurement") || "Measurement"}
//         </button>

//         <button
//           onClick={() => setOpenFilter(openFilter === "price" ? null : "price")}
//           className={`px-4 py-2 border rounded-full ${
//             openFilter === "price" ? "bg-gray-900 text-white" : "bg-white text-black"
//           }`}
//         >
//           {t("product_filter.price") || "Price"}
//         </button>

//         <button
//           onClick={() =>
//             setOpenFilter(openFilter === "rating" ? null : "rating")
//           }
//           className={`px-4 py-2 border rounded-full ${
//             openFilter === "rating" ? "bg-gray-900 text-white" : "bg-white text-black"
//           }`}
//         >
//           {t("product_filter.rating") || "Rating"}
//         </button>

//         <button
//           onClick={() => setOpenFilter(openFilter === "brand" ? null : "brand")}
//           className={`px-4 py-2 border rounded-full ${
//             openFilter === "brand" ? "bg-gray-900 text-white" : "bg-white text-black"
//           }`}
//         >
//           {t("product_filter.brand") || "Brand"}
//         </button>

//         <button
//           onClick={() =>
//             setOpenFilter(openFilter === "material" ? null : "material")
//           }
//           className={`px-4 py-2 border rounded-full ${
//             openFilter === "material" ? "bg-gray-900 text-white" : "bg-white text-black"
//           }`}
//         >
//           {t("product_filter.material") || "Material"}
//         </button>

//         <button
//           onClick={resetFilters}
//           className="px-4 py-2 border rounded-full bg-red-50 text-red-600 hover:bg-red-100"
//         >
//           {t("product_filter.reset") || "Reset"}
//         </button>
//       </div>

//       {/* FILTER PANELS */}
//       {/* PRICE FILTER */}
//       {openFilter === "price" && (
//         <div className="mb-6 p-4 border rounded">
//           <button
//             onClick={() => setPriceSort("asc")}
//             className={`px-3 py-2 border rounded ${
//               priceSort === "asc" && "bg-gray-900 text-white"
//             }`}
//           >
//             {t("product_filter.low_to_high") || "Low → High"}
//           </button>

//           <button
//             onClick={() => setPriceSort("desc")}
//             className={`px-3 py-2 border rounded ml-2 ${
//               priceSort === "desc" && "bg-gray-900 text-white"
//             }`}
//           >
//             {t("product_filter.high_to_low") || "High → Low"}
//           </button>
//         </div>
//       )}

//       {/* BRAND FILTER */}
//       {openFilter === "brand" && (
//         <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
//           {brandOptions.map((b) => (
//             <button
//               key={b}
//               onClick={() => toggleSet(setSelectedBrands, selectedBrands, b)}
//               className={`px-3 py-1 border rounded ${
//                 selectedBrands.has(b) && "bg-gray-900 text-white"
//               }`}
//             >
//               {b}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* MATERIAL FILTER */}
//       {openFilter === "material" && (
//         <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
//           {materialOptions.map((m) => (
//             <button
//               key={m}
//               onClick={() =>
//                 toggleSet(setSelectedMaterials, selectedMaterials, m)
//               }
//               className={`px-3 py-1 border rounded ${
//                 selectedMaterials.has(m) && "bg-gray-900 text-white"
//               }`}
//             >
//               {m}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* HEIGHT FILTER */}
//       {openFilter === "height" && (
//         <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
//           {heightOptions.map((h) => (
//             <button
//               key={h}
//               onClick={() => toggleSet(setSelectedHeights, selectedHeights, h)}
//               className={`px-3 py-1 border rounded ${
//                 selectedHeights.has(h) && "bg-gray-900 text-white"
//               }`}
//             >
//               {h}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* WEIGHT FILTER */}
//       {openFilter === "weight" && (
//         <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
//           {weightOptions.map((w) => (
//             <button
//               key={w}
//               onClick={() => toggleSet(setSelectedWeights, selectedWeights, w)}
//               className={`px-3 py-1 border rounded ${
//                 selectedWeights.has(w) && "bg-gray-900 text-white"
//               }`}
//             >
//               {w}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* MEASUREMENT FILTER */}
//       {openFilter === "measurement" && (
//         <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
//           {measurementOptions.map((m) => (
//             <button
//               key={m}
//               onClick={() =>
//                 toggleSet(setSelectedMeasurements, selectedMeasurements, m)
//               }
//               className={`px-3 py-1 border rounded ${
//                 selectedMeasurements.has(m) && "bg-gray-900 text-white"
//               }`}
//             >
//               {m}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* RATING FILTER */}
//       {openFilter === "rating" && (
//         <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
//           {ratingOptions.map((r) => (
//             <button
//               key={r}
//               onClick={() => setRatingMin(r)}
//               className={`px-3 py-1 border rounded ${
//                 ratingMin === r ? "bg-gray-900 text-white" : ""
//               }`}
//             >
//               {r} ★ {t("product_filter.and_up") || "& Up"}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* ACTIVE FILTERS SUMMARY */}
//       {(selectedBrands.size > 0 || selectedMaterials.size > 0 || 
//         selectedHeights.size > 0 || selectedWeights.size > 0 || 
//         selectedMeasurements.size > 0 || ratingMin > 0 || priceSort) && (
//         <div className="mb-6 p-3 bg-gray-50 rounded border">
//           <p className="text-sm font-medium text-gray-700 mb-2">
//             {t("product_filter.active_filters") || "Active Filters:"}
//           </p>
//           <div className="flex flex-wrap gap-2">
//             {selectedBrands.size > 0 && [...selectedBrands].map(brand => (
//               <span key={brand} className="px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded">
//                 {t("product_filter.brand") || "Brand"}: {brand}
//               </span>
//             ))}
//             {selectedMaterials.size > 0 && [...selectedMaterials].map(material => (
//               <span key={material} className="px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded">
//                 {t("product_filter.material") || "Material"}: {material}
//               </span>
//             ))}
//             {ratingMin > 0 && (
//               <span className="px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded">
//                 {t("product_filter.rating") || "Rating"}: ≥ {ratingMin}★
//               </span>
//             )}
//             {priceSort && (
//               <span className="px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded">
//                 {t("product_filter.price") || "Price"}: {priceSort === "asc" ? "Low to High" : "High to Low"}
//               </span>
//             )}
//           </div>
//         </div>
//       )}

//       {/* PRODUCT GRID */}
//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
//         {filteredProducts.map((product, index) => {
//           const id = product._id.toString();
//           const isCartLoading = loadingCart.has(id);
//           const productName = getLocalizedText(product, "name") || product?.name || t("product_filter.untitled_product") || "Untitled Product";
//           const productImage = product.images?.[0] || "https://via.placeholder.com/300x300?text=No+Image";

//           return (
//             <React.Fragment key={id}>
//               <div
//                 className="group bg-[#f7f3f3] rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all cursor-pointer duration-300 relative"
//                 onClick={() => navigate(`/product-details/${id}`)}
//                 data-aos="fade-up"
//               >
//                 {/* Wishlist */}
//                 <button
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     toggleWishlist(id);
//                   }}
//                   className="absolute top-3 right-3 z-10 p-2 rounded-full bg-white/90 shadow-md hover:bg-gray-100 transition-all duration-300"
//                   aria-label={wishlist.includes(id) ? 
//                     t("product_filter.remove_wishlist") || "Remove from wishlist" : 
//                     t("product_filter.add_wishlist") || "Add to wishlist"
//                   }
//                 >
//                   {loadingHearts.has(id) ? (
//                     <Loader2 className="w-4 h-4 animate-spin text-red-500" />
//                   ) : wishlist.includes(id) ? (
//                     <Heart className="w-5 h-5 fill-red-500 stroke-red-500" />
//                   ) : (
//                     <Heart className="w-5 h-5 stroke-gray-600" />
//                   )}
//                 </button>

//                 {/* Image */}
//                 <div className="relative bg-[#E5E5E5] overflow-hidden aspect-square">
//                   <img
//                     src={productImage}
//                     alt={productName}
//                     className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                     onError={(e) => {
//                       e.target.src = "https://via.placeholder.com/300x300?text=No+Image";
//                     }}
//                   />
//                 </div>

//                 {/* Info */}
//                 <div className="p-3 text-center">
//                   {renderStars(product.ratings || 0)}

//                   <h3 
//                     className="text-xs sm:text-sm text-gray-700 text-center mb-2 line-clamp-2 min-h-[2.5rem] leading-tight"
//                     title={productName}
//                   >
//                     {productName}
//                   </h3>

//                   <div className="text-center">
//                     <div className="flex items-center justify-center flex-col gap-2">
//                       {product.previous_price && product.previous_price > product.price && (
//                         <div className="text-xs sm:text-sm text-gray-400 line-through">
//                           {formatingPrice(
//                             convertPrice(product.previous_price),
//                             currency
//                           )}
//                         </div>
//                       )}
//                       <div className="text-base sm:text-lg font-bold text-gray-900">
//                         {formatingPrice(convertPrice(product.price), currency)}
//                       </div>
//                     </div>
//                   </div>
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleAddToCart(id);
//                     }}
//                     disabled={isCartLoading}
//                     className="mt-3 w-full bg-white border-2 border-gray-900 text-gray-900 py-2.5 text-sm font-bold rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-70"
//                   >
//                     {isCartLoading ? (
//                       <div className="flex justify-center items-center gap-2">
//                         <Loader2 className="w-4 h-4 animate-spin" />
//                         {t("product_filter.adding") || "ADDING..."}
//                       </div>
//                     ) : (
//                       t("product_filter.add_to_cart") || "ADD TO CART"
//                     )}
//                   </button>
//                 </div>
//               </div>

//               {/* BANNER AFTER 10 PRODUCTS */}
//               {index === 9 && (
//                 <div className="col-span-full" data-aos="fade-up">
//                   <img
//                     src={bannerone}
//                     alt={t("product_filter.banner_alt") || "Special Offer Banner"}
//                     className="w-full rounded-lg"
//                   />
//                 </div>
//               )}
//             </React.Fragment>
//           );
//         })}
//       </div>

//       {filteredProducts.length === 0 && !searchQuery && (
//         <div className="text-center py-10 text-gray-500">
//           {t("product_filter.no_products") || "No products found."}
//         </div>
//       )}
//     </div>
//   );
// };

// export default ProductFilterSection;






import React, { useEffect, useMemo, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import bannerone from "../../Assets/Banner/Wooden Craft.png";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../utils/CartContext";
import { Star, Loader2, Heart } from "lucide-react";
import { useCurrency } from "../../context/CurrencyContext";
import { formatingPrice } from "../../utils/formatingPrice";
import { useTranslation } from "react-i18next";
import GuestSession from "../../utils/guestSession";

const ProductFilterSection = ({ products = [], loading, searchQuery }) => {
  const navigate = useNavigate();
  const { fetchCartCount } = useCart();
  const { currency, convertPrice } = useCurrency();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  // FILTER STATES
  const [openFilter, setOpenFilter] = useState(null);
  const [priceSort, setPriceSort] = useState(null);
  const [ratingMin, setRatingMin] = useState(0);
  const [selectedBrands, setSelectedBrands] = useState(new Set());
  const [selectedMaterials, setSelectedMaterials] = useState(new Set());
  const [selectedHeights, setSelectedHeights] = useState(new Set());
  const [selectedWeights, setSelectedWeights] = useState(new Set());
  const [selectedMeasurements, setSelectedMeasurements] = useState(new Set());
  const ratingOptions = [5, 4, 3, 2, 1];

  // WISHLIST + CART
  const [wishlist, setWishlist] = useState([]);
  const [loadingHearts, setLoadingHearts] = useState(new Set());
  const [loadingCart, setLoadingCart] = useState(new Set());

  const storedUser = localStorage.getItem("pm-user-data");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const userId = user?._id;
  const isLoggedIn = !!userId;

  // Helper function to get localized text
  const getLocalizedText = (item, field) => {
    if (!item || !item[field]) return "";
    
    if (typeof item[field] === 'string') {
      return item[field];
    }
    
    if (typeof item[field] === 'object') {
      return item[field][currentLanguage] || 
             item[field].en || 
             item[field].hi || 
             item[field].es || 
             item[field].zh || 
             "";
    }
    
    return "";
  };

  // INIT AOS
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    fetchWishlist();
  }, [userId]);

  // Listen for guest wishlist updates
  useEffect(() => {
    const handleGuestWishlistUpdate = () => {
      if (!isLoggedIn) {
        const guestWishlist = JSON.parse(localStorage.getItem('guestWishlist') || '[]');
        setWishlist(guestWishlist);
      }
    };
    window.addEventListener('guest-wishlist-updated', handleGuestWishlistUpdate);
    return () => window.removeEventListener('guest-wishlist-updated', handleGuestWishlistUpdate);
  }, [isLoggedIn]);

  // Fetch wishlist - works for both logged in and guest
  const fetchWishlist = async () => {
    try {
      if (isLoggedIn) {
        // Logged in user - fetch from API
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/wishlist/wishlist-by-user/${userId}`
        );
        const ids = res?.data?.products?.map((p) => p._id?.toString()) || [];
        setWishlist(ids);
      } else {
        // Guest user - get from localStorage
        const guestWishlist = JSON.parse(localStorage.getItem('guestWishlist') || '[]');
        setWishlist(guestWishlist);
      }
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    }
  };

  // Toggle wishlist - works for both logged in and guest
  const toggleWishlist = async (productId) => {
    const isLiked = wishlist.includes(productId);
    setLoadingHearts((prev) => new Set(prev).add(productId));

    try {
      if (isLoggedIn) {
        // Logged in user
        const endpoint = isLiked
          ? `${process.env.REACT_APP_API_URL}/wishlist/remove-from-wishlist`
          : `${process.env.REACT_APP_API_URL}/wishlist/add-to-wishlist`;
        await axios.post(endpoint, { userId, productId });
        await fetchWishlist();
        toast.success(
          isLiked 
            ? t("product_filter.removed_wishlist") || "Removed from wishlist"
            : t("product_filter.added_wishlist") || "Added to wishlist"
        );
      } else {
        // Guest user - use localStorage
        let guestWishlist = JSON.parse(localStorage.getItem('guestWishlist') || '[]');
        if (isLiked) {
          guestWishlist = guestWishlist.filter(id => id !== productId);
        } else {
          guestWishlist.push(productId);
        }
        localStorage.setItem('guestWishlist', JSON.stringify(guestWishlist));
        setWishlist(guestWishlist);
        window.dispatchEvent(new Event('guest-wishlist-updated'));
        toast.success(
          isLiked 
            ? t("product_filter.removed_wishlist") || "Removed from wishlist"
            : t("product_filter.added_wishlist") || "Added to wishlist"
        );
      }
    } catch (error) {
      toast.error(t("product_filter.wishlist_error") || "Failed to update wishlist");
    } finally {
      setLoadingHearts((prev) => {
        const n = new Set(prev);
        n.delete(productId);
        return n;
      });
    }
  };

  // Add to cart - works for both logged in and guest
  const handleAddToCart = async (productId) => {
    setLoadingCart((prev) => new Set(prev).add(productId));

    try {
      if (isLoggedIn) {
        // Logged in user
        await axios.post(
          `${process.env.REACT_APP_API_URL}/cart/add-to-cart`,
          {
            userId,
            productId,
            quantity: 1,
          }
        );
      } else {
        // Guest user
        const guestId = GuestSession.getGuestId();
        await axios.post(
          `${process.env.REACT_APP_API_URL}/cart/add-to-cart`,
          {
            guestId,
            productId,
            quantity: 1,
          }
        );
      }
      toast.success(t("product_filter.added_cart") || "Added to cart!");
      await fetchCartCount();
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error(error.response?.data?.message || t("product_filter.cart_error") || "Failed to add to cart");
    } finally {
      setLoadingCart((prev) => {
        const n = new Set(prev);
        n.delete(productId);
        return n;
      });
    }
  };

  // Filter options - use localized text for display
  const heightOptions = useMemo(() => {
    const s = new Set();
    products?.forEach((p) => {
      const height = p.height;
      if (height) s.add(height);
    });
    return [...s];
  }, [products]);

  const weightOptions = useMemo(() => {
    const s = new Set();
    products?.forEach((p) => {
      const weight = p.weight;
      if (weight) s.add(weight);
    });
    return [...s];
  }, [products]);

  const measurementOptions = useMemo(() => {
    const s = new Set();
    products?.forEach((p) => {
      const measurement = getLocalizedText(p, "measurement");
      if (measurement) s.add(measurement);
    });
    return [...s];
  }, [products, getLocalizedText]);

  const brandOptions = useMemo(() => {
    const s = new Set();
    products?.forEach((p) => {
      const brand = p.brand;
      if (brand) s.add(brand);
    });
    return [...s];
  }, [products]);

  const materialOptions = useMemo(() => {
    const s = new Set();
    products?.forEach((p) => {
      const material = getLocalizedText(p, "material");
      if (material) s.add(material);
    });
    return [...s];
  }, [products, getLocalizedText]);

  // Apply filters
  const filteredProducts = useMemo(() => {
    let list = [...products];

    // Rating filter
    if (ratingMin > 0) {
      list = list.filter((p) => {
        const r = typeof p.ratings === "number" ? p.ratings : 0;
        return r >= ratingMin;
      });
    }

    // Brand filter
    if (selectedBrands.size > 0) {
      list = list.filter((p) => selectedBrands.has(p.brand));
    }

    // Material filter
    if (selectedMaterials.size > 0) {
      list = list.filter((p) => {
        const materialText = getLocalizedText(p, "material");
        return selectedMaterials.has(materialText);
      });
    }

    // Height filter
    if (selectedHeights.size > 0) {
      list = list.filter((p) => selectedHeights.has(p.height));
    }

    // Weight filter
    if (selectedWeights.size > 0) {
      list = list.filter((p) => selectedWeights.has(p.weight));
    }

    // Measurement filter
    if (selectedMeasurements.size > 0) {
      list = list.filter((p) => {
        const measurementText = getLocalizedText(p, "measurement");
        return selectedMeasurements.has(measurementText);
      });
    }

    // Price sort
    if (priceSort === "asc") list.sort((a, b) => a.price - b.price);
    if (priceSort === "desc") list.sort((a, b) => b.price - a.price);

    return list;
  }, [
    products,
    priceSort,
    ratingMin,
    selectedBrands,
    selectedMaterials,
    selectedHeights,
    selectedWeights,
    selectedMeasurements,
    getLocalizedText,
  ]);

  // toggle set
  const toggleSet = (setter, refSet, value) => {
    const s = new Set(refSet);
    s.has(value) ? s.delete(value) : s.add(value);
    setter(s);
  };

  // Reset filters
  const resetFilters = () => {
    setPriceSort(null);
    setRatingMin(0);
    setSelectedBrands(new Set());
    setSelectedMaterials(new Set());
    setSelectedHeights(new Set());
    setSelectedWeights(new Set());
    setSelectedMeasurements(new Set());
    setOpenFilter(null);
  };

  // Star Renderer
  const renderStars = (rating) => (
    <div className="flex justify-center gap-1 mb-2">
      {[...Array(5)].map((_, index) => (
        <Star
          key={index}
          className={`w-4 h-4 ${
            index < Math.round(rating)
              ? "text-yellow-400 fill-yellow-400"
              : "text-gray-300"
          }`}
        />
      ))}
      {rating && (
        <span className="text-xs text-gray-500 ml-1">{rating.toFixed(1)}</span>
      )}
    </div>
  );

  // SHOW LOADER
  if (loading)
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-7 gap-4 px-4 md:px-10 py-10">
        {[...Array(14)].map((_, i) => (
          <div
            key={i}
            className="bg-[#f7f3f3] rounded-lg overflow-hidden shadow-sm animate-pulse"
          >
            <div className="w-full aspect-square bg-gray-300"></div>
            <div className="p-3 space-y-3">
              <div className="flex justify-center gap-2">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
              </div>
              <div className="h-3 bg-gray-300 rounded w-3/4 mx-auto"></div>
              <div className="h-3 bg-gray-300 rounded w-1/2 mx-auto"></div>
              <div className="flex justify-center gap-3">
                <div className="h-4 bg-gray-300 rounded w-12"></div>
                <div className="h-4 bg-gray-300 rounded w-16"></div>
              </div>
              <div className="h-8 bg-gray-300 rounded w-full mt-4"></div>
            </div>
          </div>
        ))}
      </div>
    );

  // Show no results message for search
  if (searchQuery && filteredProducts.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="max-w-md mx-auto">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">
            {t("product_filter.no_search_results") || "No products found"}
          </h3>
          <p className="text-gray-600 mb-6">
            {t("product_filter.try_different_search") || "Try a different search term"}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white py-10 px-4 md:px-10">
      {/* Results count */}
      {searchQuery && (
        <div className="mb-6">
          <p className="text-gray-600">
            {t("product_filter.results_found", { count: filteredProducts.length }) || 
              `${filteredProducts.length} results found`}
          </p>
        </div>
      )}

      {/* FILTER BUTTONS */}
      <div className="flex flex-wrap gap-2 mb-6">
        <button
          onClick={() => setOpenFilter(openFilter === "all" ? null : "all")}
          className={`px-4 py-2 border rounded-full ${
            openFilter === "all" ? "bg-black text-white" : "bg-white text-black"
          }`}
        >
          {t("product_filter.all_filters") || "All Filters"}
        </button>

        <button
          onClick={() =>
            setOpenFilter(openFilter === "height" ? null : "height")
          }
          className={`px-4 py-2 border rounded-full ${
            openFilter === "height" ? "bg-gray-900 text-white" : "bg-white text-black"
          }`}
        >
          {t("product_filter.height") || "Height"}
        </button>

        <button
          onClick={() =>
            setOpenFilter(openFilter === "weight" ? null : "weight")
          }
          className={`px-4 py-2 border rounded-full ${
            openFilter === "weight" ? "bg-gray-900 text-white" : "bg-white text-black"
          }`}
        >
          {t("product_filter.weight") || "Weight"}
        </button>

        <button
          onClick={() =>
            setOpenFilter(openFilter === "measurement" ? null : "measurement")
          }
          className={`px-4 py-2 border rounded-full ${
            openFilter === "measurement" ? "bg-gray-900 text-white" : "bg-white text-black"
          }`}
        >
          {t("product_filter.measurement") || "Measurement"}
        </button>

        <button
          onClick={() => setOpenFilter(openFilter === "price" ? null : "price")}
          className={`px-4 py-2 border rounded-full ${
            openFilter === "price" ? "bg-gray-900 text-white" : "bg-white text-black"
          }`}
        >
          {t("product_filter.price") || "Price"}
        </button>

        <button
          onClick={() =>
            setOpenFilter(openFilter === "rating" ? null : "rating")
          }
          className={`px-4 py-2 border rounded-full ${
            openFilter === "rating" ? "bg-gray-900 text-white" : "bg-white text-black"
          }`}
        >
          {t("product_filter.rating") || "Rating"}
        </button>

        <button
          onClick={() => setOpenFilter(openFilter === "brand" ? null : "brand")}
          className={`px-4 py-2 border rounded-full ${
            openFilter === "brand" ? "bg-gray-900 text-white" : "bg-white text-black"
          }`}
        >
          {t("product_filter.brand") || "Brand"}
        </button>

        <button
          onClick={() =>
            setOpenFilter(openFilter === "material" ? null : "material")
          }
          className={`px-4 py-2 border rounded-full ${
            openFilter === "material" ? "bg-gray-900 text-white" : "bg-white text-black"
          }`}
        >
          {t("product_filter.material") || "Material"}
        </button>

        <button
          onClick={resetFilters}
          className="px-4 py-2 border rounded-full bg-red-50 text-red-600 hover:bg-red-100"
        >
          {t("product_filter.reset") || "Reset"}
        </button>
      </div>

      {/* PRICE FILTER */}
      {openFilter === "price" && (
        <div className="mb-6 p-4 border rounded">
          <button
            onClick={() => setPriceSort("asc")}
            className={`px-3 py-2 border rounded ${
              priceSort === "asc" && "bg-gray-900 text-white"
            }`}
          >
            {t("product_filter.low_to_high") || "Low → High"}
          </button>

          <button
            onClick={() => setPriceSort("desc")}
            className={`px-3 py-2 border rounded ml-2 ${
              priceSort === "desc" && "bg-gray-900 text-white"
            }`}
          >
            {t("product_filter.high_to_low") || "High → Low"}
          </button>
        </div>
      )}

      {/* BRAND FILTER */}
      {openFilter === "brand" && (
        <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
          {brandOptions.map((b) => (
            <button
              key={b}
              onClick={() => toggleSet(setSelectedBrands, selectedBrands, b)}
              className={`px-3 py-1 border rounded ${
                selectedBrands.has(b) && "bg-gray-900 text-white"
              }`}
            >
              {b}
            </button>
          ))}
        </div>
      )}

      {/* MATERIAL FILTER */}
      {openFilter === "material" && (
        <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
          {materialOptions.map((m) => (
            <button
              key={m}
              onClick={() =>
                toggleSet(setSelectedMaterials, selectedMaterials, m)
              }
              className={`px-3 py-1 border rounded ${
                selectedMaterials.has(m) && "bg-gray-900 text-white"
              }`}
            >
              {m}
            </button>
          ))}
        </div>
      )}

      {/* HEIGHT FILTER */}
      {openFilter === "height" && (
        <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
          {heightOptions.map((h) => (
            <button
              key={h}
              onClick={() => toggleSet(setSelectedHeights, selectedHeights, h)}
              className={`px-3 py-1 border rounded ${
                selectedHeights.has(h) && "bg-gray-900 text-white"
              }`}
            >
              {h}
            </button>
          ))}
        </div>
      )}

      {/* WEIGHT FILTER */}
      {openFilter === "weight" && (
        <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
          {weightOptions.map((w) => (
            <button
              key={w}
              onClick={() => toggleSet(setSelectedWeights, selectedWeights, w)}
              className={`px-3 py-1 border rounded ${
                selectedWeights.has(w) && "bg-gray-900 text-white"
              }`}
            >
              {w}
            </button>
          ))}
        </div>
      )}

      {/* MEASUREMENT FILTER */}
      {openFilter === "measurement" && (
        <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
          {measurementOptions.map((m) => (
            <button
              key={m}
              onClick={() =>
                toggleSet(setSelectedMeasurements, selectedMeasurements, m)
              }
              className={`px-3 py-1 border rounded ${
                selectedMeasurements.has(m) && "bg-gray-900 text-white"
              }`}
            >
              {m}
            </button>
          ))}
        </div>
      )}

      {/* RATING FILTER */}
      {openFilter === "rating" && (
        <div className="mb-6 p-4 border rounded flex gap-2 flex-wrap">
          {ratingOptions.map((r) => (
            <button
              key={r}
              onClick={() => setRatingMin(r)}
              className={`px-3 py-1 border rounded ${
                ratingMin === r ? "bg-gray-900 text-white" : ""
              }`}
            >
              {r} ★ {t("product_filter.and_up") || "& Up"}
            </button>
          ))}
        </div>
      )}

      {/* ACTIVE FILTERS SUMMARY */}
      {(selectedBrands.size > 0 || selectedMaterials.size > 0 || 
        selectedHeights.size > 0 || selectedWeights.size > 0 || 
        selectedMeasurements.size > 0 || ratingMin > 0 || priceSort) && (
        <div className="mb-6 p-3 bg-gray-50 rounded border">
          <p className="text-sm font-medium text-gray-700 mb-2">
            {t("product_filter.active_filters") || "Active Filters:"}
          </p>
          <div className="flex flex-wrap gap-2">
            {selectedBrands.size > 0 && [...selectedBrands].map(brand => (
              <span key={brand} className="px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded">
                {t("product_filter.brand") || "Brand"}: {brand}
              </span>
            ))}
            {selectedMaterials.size > 0 && [...selectedMaterials].map(material => (
              <span key={material} className="px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded">
                {t("product_filter.material") || "Material"}: {material}
              </span>
            ))}
            {ratingMin > 0 && (
              <span className="px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded">
                {t("product_filter.rating") || "Rating"}: ≥ {ratingMin}★
              </span>
            )}
            {priceSort && (
              <span className="px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded">
                {t("product_filter.price") || "Price"}: {priceSort === "asc" ? "Low to High" : "High to Low"}
              </span>
            )}
          </div>
        </div>
      )}

      {/* PRODUCT GRID */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-7 gap-4">
        {filteredProducts.map((product, index) => {
          const id = product._id.toString();
          const isCartLoading = loadingCart.has(id);
          const isLiked = wishlist.includes(id);
          const isHeartLoading = loadingHearts.has(id);
          const productName = getLocalizedText(product, "name") || product?.name || t("product_filter.untitled_product") || "Untitled Product";
          const productImage = product.images?.[0] || "https://via.placeholder.com/300x300?text=No+Image";

          return (
            <React.Fragment key={id}>
              <div
                className="group bg-[#f7f3f3] rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all cursor-pointer duration-300 relative"
                onClick={() => navigate(`/product-details/${id}`)}
                data-aos="fade-up"
              >
                {/* Wishlist */}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleWishlist(id);
                  }}
                  disabled={isHeartLoading}
                  className="absolute top-3 right-3 z-10 p-2 rounded-full bg-white/90 shadow-md hover:bg-gray-100 transition-all duration-300"
                  aria-label={isLiked ? 
                    t("product_filter.remove_wishlist") || "Remove from wishlist" : 
                    t("product_filter.add_wishlist") || "Add to wishlist"
                  }
                >
                  {isHeartLoading ? (
                    <Loader2 className="w-4 h-4 animate-spin text-red-500" />
                  ) : isLiked ? (
                    <Heart className="w-5 h-5 fill-red-500 stroke-red-500" />
                  ) : (
                    <Heart className="w-5 h-5 stroke-gray-600" />
                  )}
                </button>

                {/* Image */}
                <div className="relative bg-[#E5E5E5] overflow-hidden aspect-square">
                  <img
                    src={productImage}
                    alt={productName}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/300x300?text=No+Image";
                    }}
                  />
                </div>

                {/* Info */}
                <div className="p-3 text-center">
                  {renderStars(product.ratings || 0)}

                  <h3 
                    className="font-semibold text-sm text-gray-700 text-center mb-2 line-clamp-2 min-h-[2.5rem] leading-tight"
                    title={productName}
                  >
                    {productName}
                  </h3>

                  <div className="text-center">
                    <div className="flex items-center justify-center gap-2">
                      {product.previous_price && product.previous_price > product.price && (
                        <div className="text-sm text-red-400 line-through">
                          {formatingPrice(
                            convertPrice(product.previous_price),
                            currency
                          )}
                        </div>
                      )}
                      <div className="text-base font-semibold text-gray-900">
                        {formatingPrice(convertPrice(product.price), currency)}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddToCart(id);
                    }}
                    disabled={isCartLoading}
                    className="mt-3 w-full bg-white border-2 border-gray-900 text-gray-900 py-2 text-sm font-medium rounded-lg hover:bg-gray-900 hover:text-white transition-all duration-300 transform hover:scale-[1.02] disabled:opacity-70"
                  >
                    {isCartLoading ? (
                      <div className="flex justify-center items-center gap-2">
                        <Loader2 className="w-4 h-4 animate-spin" />
                        {t("product_filter.adding") || "ADDING..."}
                      </div>
                    ) : (
                      t("product_filter.add_to_cart") || "ADD TO CART"
                    )}
                  </button>
                </div>
              </div>

              {/* BANNER AFTER 14 PRODUCTS */}
              {index === 13 && (
                <div className="col-span-full" data-aos="fade-up">
                  <img
                    src={bannerone}
                    alt={t("product_filter.banner_alt") || "Special Offer Banner"}
                    className="w-full rounded-lg"
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      {filteredProducts.length === 0 && !searchQuery && (
        <div className="text-center py-10 text-gray-500">
          {t("product_filter.no_products") || "No products found."}
        </div>
      )}
    </div>
  );
};

export default ProductFilterSection;